import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = ({authenticated}) => {

  useEffect(() => {
    localStorage.setItem("authenticated", authenticated);
  }, [authenticated]);
  
  return  authenticated  ? <Outlet /> : <Navigate to={`${process.env.PUBLIC_URL}/login`} />;
};

export default PrivateRoute;
  